import { Delete, Sms } from "@mui/icons-material";
import {
  Avatar,
  Collapse,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { TransitionGroup } from "react-transition-group";
import {
  useMessageScheduleHandlers,
  useMessageScheduleState,
} from "../../../../App/State/Hooks/MessageDialog/useMessageSchedule";
import createSlug from "../../../../App/Utilities/createSlug";
import { IMessageScheduleQueue } from "../../../../App/Typings/MessageText";
import { useUserProfileStore } from "../../../../App/State/Stores/UserProfileStore";

export default function PendingMessageQueue() {
  const scheduleState = useMessageScheduleState();
  const { handleDeleteMessageFromQueue } = useMessageScheduleHandlers();
  const msgListQueueSorted = [...scheduleState.msgListQueue].sort((a, b) => {
    if (a.date > b.date) return 1;
    if (b.date > a.date) return -1;

    return 0;
  });

  const { getUserAdjustedDate } = useUserProfileStore();

  const messageStringBuilder = (msg: IMessageScheduleQueue) => {
    const scheduleDate = getUserAdjustedDate(msg.date);
    const date = scheduleDate.format("MM/DD/YYYY");
    const time = scheduleDate.format("h:mm A");
    const excerpt = limitStringLength(msg);
    return `[${date} ${time}] ${excerpt}`;
  };

  return (
    <Collapse in={scheduleState.msgListQueue.length > 0} unmountOnExit sx={{ width: "100%" }}>
      <Grid item xs={12} md={6} width="100%">
        <Typography sx={{ mt: 3, mb: 2 }} variant="h6" component="div">
          Messages To Schedule ({scheduleState.msgListQueue.length})
        </Typography>
        <List data-test="pending-message-list" sx={{ p: 0, borderTop: "1px solid #e0e0e0", pb: 2 }}>
          <TransitionGroup>
            {msgListQueueSorted.map((msg) => (
              <Collapse key={msg.id.toString()}>
                <ListItem
                  data-test={`pending-message-list-item-${createSlug(msg.title)}`}
                  sx={{ borderBottom: "1px solid #e0e0e0" }}
                  secondaryAction={
                    <Tooltip title="Delete Queued Message">
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => handleDeleteMessageFromQueue(msg)}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  }
                >
                  <ListItemAvatar>
                    <Avatar>
                      <Sms />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={messageStringBuilder(msg)} />
                </ListItem>
              </Collapse>
            ))}
          </TransitionGroup>
        </List>
      </Grid>
    </Collapse>
  );
}

const limitStringLength = (msg: IMessageScheduleQueue) => {
  const bodyLength = msg.bodyRaw.length;
  const titleLength = msg.title.length;
  if (titleLength > 0) {
    if (titleLength > 50) {
      return msg.title.substring(0, 50);
    }
    return msg.title;
  } else {
    if (bodyLength > 50) {
      return msg.bodyRaw.substring(0, 50);
    }
    return msg.bodyRaw;
  }
};
